(function () {
  var iframeId = "mikko-chat";
  var encodedAppUrl = "aHR0cHM6Ly90ZWtvYWx5bWlra28ueHl6Lw==";
  var extraAllowedOrigins = ["https://tekoalymikko.xyz"];

  function decodeAppUrl() {
    try {
      return window.atob(encodedAppUrl);
    } catch (err) {
      return "";
    }
  }

  function clampNumber(value, fallback, min, max) {
    var n = Number(value);
    if (!Number.isFinite(n)) return fallback;
    return Math.min(Math.max(n, min), max);
  }

  function isMobileViewport() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function buildFrameUrl(appUrl) {
    try {
      var url = new URL(appUrl);
      url.searchParams.set("embedUrl", window.location.href);
      return url.toString();
    } catch (err) {
      return appUrl;
    }
  }

  function initMikkoChat() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (document.getElementById(iframeId)) return;

    var appUrl = decodeAppUrl();
    if (!appUrl) return;

    var appOrigin;
    try {
      appOrigin = new URL(appUrl).origin;
    } catch (err) {
      return;
    }
    var activeAppOrigin = appOrigin;

    function isAllowedOrigin(origin) {
      if (origin === appOrigin) return true;
      return extraAllowedOrigins.indexOf(origin) !== -1;
    }

    var initialRevealTimer = 0;
    var initialMeasurementAt = 0;

    var lastFrameMeasurement = null;

    function syncCompactHitArea() {
      // The embedded 56px launcher reports a 140px frame including shadow space.
      // Clip that transparent space without resizing the child viewport. Expanded
      // chat and proactive popup measurements must remain completely unclipped.
      var data = lastFrameMeasurement;
      if (!data || data.open === true || Number(data.height) !== 140) {
        iframe.style.clipPath = "";
        return;
      }

      var width = clampNumber(data.width, 0, 0, window.innerWidth);
      var height = clampNumber(data.height, 0, 0, window.innerHeight);
      var margin = window.matchMedia("(pointer: fine)").matches ? 20 : 12;
      var shadowBleed = 12;
      var launcherWidth = Math.min(368, width - 24);
      var top = Math.max(0, height - margin - 56 - shadowBleed);
      var side = Math.max(0, margin - shadowBleed);
      var left = Math.max(0, width - margin - launcherWidth - shadowBleed);
      iframe.style.clipPath = "inset(" + top + "px " + side + "px " + side + "px " + left + "px)";
    }

    function setMeasuredFrame(data) {
      var nextOpen = data.open === true;
      var initialSettled = iframe.getAttribute("data-mikko-initial-settled") === "1";
      iframe.setAttribute("data-mikko-open", nextOpen ? "1" : "0");
      iframe.setAttribute("data-mikko-measured", "1");
      iframe.style.bottom = "0";
      iframe.style.width = clampNumber(data.width, 0, 0, window.innerWidth) + "px";
      iframe.style.height = clampNumber(data.height, 0, 0, window.innerHeight) + "px";
      lastFrameMeasurement = data;
      syncCompactHitArea();

      if (!initialSettled) {
        if (!initialMeasurementAt) initialMeasurementAt = Date.now();
        iframe.removeAttribute("data-mikko-visible");
        iframe.style.visibility = "hidden";
        iframe.style.opacity = "0";
        window.clearTimeout(initialRevealTimer);
        var initialElapsed = Date.now() - initialMeasurementAt;
        var revealDelay = Math.max(500, 2000 - initialElapsed);
        initialRevealTimer = window.setTimeout(function () {
          iframe.setAttribute("data-mikko-initial-settled", "1");
          iframe.setAttribute("data-mikko-visible", "1");
          iframe.style.visibility = "visible";
          iframe.style.opacity = "1";
        }, revealDelay);
        return;
      }

      iframe.setAttribute("data-mikko-visible", "1");
      iframe.style.visibility = "visible";
      iframe.style.opacity = "1";
    }

    var bookingOverlayOpen = false;

    function isBookingOverlayMessage(event) {
      var data = event.data;
      if (!data || typeof data !== "object" || typeof data.type !== "string") return false;
      if (data.type.slice(-8) !== ":overlay") return false;
      if (event.origin === "https://hesatek-ajanvaraus.com") return true;
      var bookingFrame = document.getElementById("hesatek");
      return Boolean(bookingFrame && event.source === bookingFrame.contentWindow);
    }

    function isBookingOverlayActive() {
      if (bookingOverlayOpen) return true;
      var bookingFrame = document.getElementById("hesatek");
      if (!bookingFrame) return false;
      var style = window.getComputedStyle(bookingFrame);
      var rect = bookingFrame.getBoundingClientRect();
      var isFullscreenish =
        rect.width >= window.innerWidth * 0.85 &&
        rect.height >= window.innerHeight * 0.75 &&
        rect.left <= window.innerWidth * 0.1 &&
        rect.top <= window.innerHeight * 0.15;
      return style.position === "fixed" && isFullscreenish;
    }

    var lastBookingHidden = null;
    function syncBookingOverlayVisibility() {
      var shouldHide = isBookingOverlayActive();
      if (shouldHide === lastBookingHidden) return;
      lastBookingHidden = shouldHide;
      iframe.setAttribute("data-mikko-hidden-for-booking", shouldHide ? "1" : "0");
      iframe.style.display = shouldHide ? "none" : "";
      iframe.style.pointerEvents = shouldHide ? "none" : "auto";
    }

    var iframe = document.createElement("iframe");
    iframe.id = iframeId;
    iframe.src = buildFrameUrl(appUrl);
    iframe.title = "Teko\u00e4ly Mikko";
    iframe.allow = "microphone; autoplay; clipboard-write";
    iframe.style.cssText = [
      "position:fixed",
      "bottom:0",
      "right:0",
      "width:0",
      "height:0",
      "max-width:100vw",
      "max-height:100vh",
      "border:0",
      "z-index:998",
      "background:transparent",
      "visibility:hidden",
      "opacity:0",
      "transition:none"
    ].join(";");

    document.body.appendChild(iframe);
    syncBookingOverlayVisibility();

    function syncMobileMenuStack(menuOpen) {
      var shouldSitBehindMenu = Boolean(menuOpen && isMobileViewport());
      iframe.setAttribute("data-mikko-behind-mobile-menu", shouldSitBehindMenu ? "1" : "0");
      iframe.style.zIndex = shouldSitBehindMenu ? "69" : "998";
    }

    document.addEventListener("hh:drawer-open", function () {
      syncMobileMenuStack(true);
    });

    document.addEventListener("hh:drawer-close", function () {
      syncMobileMenuStack(false);
    });

    syncMobileMenuStack(Boolean(document.querySelector("[data-hh-drawer].hh-is-open")));

    window.addEventListener("message", function (event) {
      if (!isBookingOverlayMessage(event)) return;
      bookingOverlayOpen = Boolean(event.data.open);
      syncBookingOverlayVisibility();
    });

    function fireMikkoOpen(source, data) {
      var key = "hesatek_mikko_chat_open_sent";
      try {
        if (window.sessionStorage && window.sessionStorage.getItem(key) === "1") return;
        if (window.sessionStorage) window.sessionStorage.setItem(key, "1");
      } catch (err) {}

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "tekoaly_mikko_chat_open",
        mikko_status: "open",
        chat_widget: "tekoaly_mikko",
        mikko_event_source: source,
        mikko_open_count: 1,
        mikko_parent_url: window.location.href,
        mikko_payload: data || null
      });
    }

    function pushMikkoEvent(data) {
      if (!data || typeof data.type !== "string") return;
      if (data.type.indexOf("hesatek:mikko-") !== 0) return;
      if (data.type === "hesatek:mikko-open") fireMikkoOpen("postmessage_mikko_open", data);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: data.type.replace("hesatek:", ""),
        mikko_event_type: data.type,
        mikko_parent_url: window.location.href,
        mikko_payload: data
      });
    }

    window.addEventListener("message", function (event) {
      if (!isAllowedOrigin(event.origin) || event.source !== iframe.contentWindow) return;
      activeAppOrigin = event.origin;
      var data = event.data;
      if (!data || typeof data !== "object") return;

      if (data.type === "hesatek:request-parent-url") {
        iframe.contentWindow.postMessage(
          { type: "hesatek:parent-url", url: window.location.href },
          event.origin
        );
      }

      if (data.type === "hesatek:resize") {
        setMeasuredFrame(data);
        if (data.open === true) {
          fireMikkoOpen("postmessage_resize_open", data);
        }
      }

      pushMikkoEvent(data);
      syncBookingOverlayVisibility();
    });

    window.addEventListener("resize", function () {
      syncCompactHitArea();
      syncBookingOverlayVisibility();
    });

    var pointerMedia = window.matchMedia("(pointer: fine)");
    if (pointerMedia.addEventListener) {
      pointerMedia.addEventListener("change", syncCompactHitArea);
    }

    // Watch only the booking frame's geometry, not every class/style change on
    // the store. Coalesce resize work and avoid reacting to our own style writes.
    var bookingFrameObserved = null;
    var bookingSyncFrame = 0;
    function scheduleBookingSync() {
      if (bookingSyncFrame) return;
      bookingSyncFrame = window.requestAnimationFrame(function () {
        bookingSyncFrame = 0;
        syncBookingOverlayVisibility();
      });
    }
    var bookingStyleObserver = new MutationObserver(scheduleBookingSync);
    function watchBookingFrame() {
      var bookingFrame = document.getElementById("hesatek");
      if (bookingFrame === bookingFrameObserved) return;
      bookingStyleObserver.disconnect();
      bookingFrameObserved = bookingFrame;
      if (bookingFrame) {
        bookingStyleObserver.observe(bookingFrame, {
          attributes: true,
          attributeFilter: ["style", "class"]
        });
      } else {
        bookingOverlayOpen = false;
      }
      scheduleBookingSync();
    }
    var overlayObserver = new MutationObserver(watchBookingFrame);
    overlayObserver.observe(document.body, { childList: true, subtree: true });
    watchBookingFrame();

    function sendUrl() {
      if (!iframe.contentWindow) return;
      iframe.contentWindow.postMessage(
        { type: "hesatek:parent-url", url: window.location.href },
        activeAppOrigin
      );
    }

    iframe.addEventListener("load", sendUrl);

    var lastUrl = window.location.href;
    function syncUrl() {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        sendUrl();
      }
    }
    window.addEventListener("popstate", syncUrl);
    window.addEventListener("hashchange", syncUrl);

    var activeMs = 0;
    var lastTick = Date.now();
    var lastInteractionAt = Date.now();
    var isVisible = document.visibilityState === "visible";
    var isFocused = document.hasFocus();

    function tick() {
      var now = Date.now();
      var elapsed = now - lastTick;
      lastTick = now;
      if (isVisible && isFocused) activeMs += elapsed;
    }

    document.addEventListener("visibilitychange", function () {
      tick();
      isVisible = document.visibilityState === "visible";
    });
    window.addEventListener("focus", function () {
      isFocused = true;
      lastTick = Date.now();
    });
    window.addEventListener("blur", function () {
      tick();
      isFocused = false;
    });

    function bumpInteraction() {
      lastInteractionAt = Date.now();
    }

    ["mousemove", "mousedown", "keydown", "touchstart", "scroll"].forEach(function (name) {
      window.addEventListener(name, bumpInteraction, { passive: true });
    });

    function scrollPercent() {
      var doc = document.documentElement;
      var max = Math.max(1, (doc.scrollHeight || 0) - window.innerHeight);
      return Math.min(100, Math.round((window.scrollY / max) * 100));
    }

    // One heartbeat replaces the separate URL/activity timers. Hidden tabs do
    // not perform layout reads or send activity messages.
    setInterval(function () {
      tick();
      if (!isVisible || !iframe.contentWindow) return;
      syncUrl();
      iframe.contentWindow.postMessage(
        {
          type: "hesatek:activity",
          activeSeconds: Math.round(activeMs / 1000),
          scrollPercent: scrollPercent(),
          lastInteractionMsAgo: Date.now() - lastInteractionAt,
          isMobile: window.matchMedia("(max-width: 768px)").matches
        },
        activeAppOrigin
      );
    }, 2000);
  }

  // The closed chat is supplementary to the page. Let the page finish its
  // initial resources and give the browser an idle turn before loading the app.
  // Keep automatic startup (including proactive help); do not gate it on clicks.
  var startupScheduled = false;
  function startWhenVisible() {
    if (document.visibilityState === "hidden") {
      startupScheduled = false;
      return;
    }
    document.removeEventListener("visibilitychange", scheduleMikkoChat);
    initMikkoChat();
  }
  function scheduleMikkoChat() {
    if (startupScheduled || document.readyState !== "complete" || document.visibilityState === "hidden") return;
    startupScheduled = true;
    if (window.requestIdleCallback) {
      window.requestIdleCallback(startWhenVisible, { timeout: 1500 });
    } else {
      window.setTimeout(startWhenVisible, 0);
    }
  }
  document.addEventListener("visibilitychange", scheduleMikkoChat);
  if (document.readyState === "complete") scheduleMikkoChat();
  else window.addEventListener("load", scheduleMikkoChat, { once: true });
})();

